__turbopack_context__.v({
  "contactInfoRow": "MOaYgq_contactInfoRow",
  "contactInfoRows": "MOaYgq_contactInfoRows",
  "grow": "MOaYgq_grow",
  "header": "MOaYgq_header",
  "infoButton": "MOaYgq_infoButton",
  "left": "MOaYgq_left",
  "orderFormatIcon": "MOaYgq_orderFormatIcon",
  "orderFormats": "MOaYgq_orderFormats",
  "outletName": "MOaYgq_outletName",
  "right": "MOaYgq_right",
  "row": "MOaYgq_row",
  "statusWrapper": "MOaYgq_statusWrapper",
  "unavailableInfo": "MOaYgq_unavailableInfo",
});
